import Sidebar from '../components/Sidebar'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { fetchRequestInfoRequest,
  fetchSidebarDataRequest,
  toggleAnnotationImageModal,
} from '../routes/signup/modules/signup'
import { toggleSubMenu } from '../modules/settings'

const mapStateToProps = state => ({
  openSubMenu: state.settings.openSubMenu,
  step: state.signup.step,
  progress: state.signup.progress,
  prefectures: state.signup.prefectures,
  addresses: state.signup.addresses,
  firstName: state.signup.firstName,
  lastName: state.signup.lastName,
  firstNameReading: state.signup.firstNameReading,
  lastNameReading: state.signup.lastNameReading,
  email: state.signup.email,
  genders: state.signup.genders,
  gender: state.signup.gender,
  patientTypes: state.signup.patientTypes,
  prefectureId: state.signup.prefectureId,
  addressId: state.signup.addressId,
  patientFirstName: state.signup.patientFirstName,
  patientLastName: state.signup.patientLastName,
  patientRestAddress: state.signup.patientRestAddress,
  hasDocument: state.signup.hasDocument,
  postOfficeDocument: state.signup.postOfficeDocument,
  terms: state.signup.terms,

  consultationOptions: state.signup.consultationOptions,
  budgets: state.signup.budgets,
  budget: state.signup.budget,
  desiredProposals: state.signup.desiredProposals,
  subjectConsultation: state.signup.subjectConsultation,
  icd10: state.signup.icd10,
  icd10Name: state.signup.icd10Name,
  icd10s: state.signup.icd10s,
  previousTreatments: state.signup.previousTreatments,
  numberHospitals: state.signup.numberHospitals,
  numberHospital: state.signup.numberHospital,
  autoSaveNotification: state.signup.autoSaveNotification,
  isSavedByCustomer: state.signup.isSavedByCustomer,
  status: state.signup.status,
  editable: state.signup.editable,
  address: state.signup.address,
  updated_at: state.signup.updatedAt,
  fileData: state.signup.fileData,
  openAnnotationImageModal: state.signup.openAnnotationImageModal,
  speciality: state.signup.speciality,
  choices: state.signup.choices,
  diseases: state.signup.diseases,
  cancerTypes: state.signup.cancerTypes,

  // Request_values
  findmeId: state.signup.findmeId,
  campaign: state.signup.campaign,
  requestId: state.signup.requestId,
  title: state.signup.title,
  patientType: state.signup.patientType,
  birthYear: state.signup.birthYear,
  cancerType: state.signup.cancerType,
  cancerStep: state.signup.cancerStep,
  cancerStepOther: state.signup.cancerStepOther,
  currentSituation: state.signup.currentSituation,
  documentState: state.signup.documentState,
  otherDocumentState: state.signup.otherDocumentState,
  wantTransfer: state.signup.wantTransfer,
  offerArea: state.signup.offerArea,
  hospitalName: state.signup.hospitalName,
  hospitalId: state.signup.hospitalId,
  doctorName: state.signup.doctorName,
  diseaseName: state.signup.diseaseName,
  diseaseNameOther: state.signup.diseaseNameOther,
  otherDiseaseNames: state.signup.otherDiseaseNames,
  otherDiseaseNamesOther: state.signup.otherDiseaseNamesOther,
  consultationOption: state.signup.consultationOption,
  consultationOptionOther: state.signup.consultationOptionOther,
  answer1Description: state.signup.answer1Description,
  answer2Description: state.signup.answer2Description,
  answer3Description: state.signup.answer3Description,
  answer4Description: state.signup.answer4Description,
  contentConsultation: state.signup.contentConsultation,
  consultationDetail: state.signup.consultationDetail,
  expirationDate: state.signup.expirationDate,
  documentByPost: state.signup.documentByPost,
  returnAddress: state.signup.returnAddress,
  files: state.signup.files,
  directoryUploads: state.signup.directoryUploads,
  directoryUploadsCount: state.signup.directoryUploadsCount,
  submissionMethod: state.signup.submissionMethod,
  freecall: state.signup.freecall,
  supportExtra: state.signup.supportExtra,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchRequestInfoRequest,
  toggleSubMenu,
  fetchSidebarDataRequest,
  toggleAnnotationImageModal,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidebar)



// WEBPACK FOOTER //
// ./src/containers/SidebarContainer.js